import Vue from 'vue'
import Router from 'vue-router'
//备份原型对象已有的push|replace方法
let push = Router.prototype.push;
let replace = Router.prototype.replace;
//重写VueRouter.prototype原型对象的push|replace方法
Router.prototype.push = function (location) {
  //调用push方法且篡改push方法内部this指向->vueRouter类的实例
  push.call(this, location, () => { }, () => { });
}
Router.prototype.replace = function (location) {
  //调用push方法且篡改push方法内部this指向->vueRouter类的实例
  replace.apply(this, [location, () => { }, () => { }]);
}
Vue.use(Router)
// 在路由加载的时候首次进来要按需加载路由，首页加载慢的问题，不要使用import换成require
export const constantRouteMap = [
  {
    path: '/',
    component: resolve => require(['@/views/login/index'], resolve),
    name: 'login',
    meta: {
      title: '健康教育平台'
    }
  }
]
const router = new Router({
  mode: 'history', // 根绝环境变量来区分是打包成APP还是网页版查看,history和mode模式
  routes: constantRouteMap
})

router.beforeEach((to,from,next)=>{ //beforeEach是router的钩子函数，在进入路由前执行
  if(to.meta.title){ //判断是否有标题
    document.title = to.meta.title
  }
  next()  //执行进入路由，如果不写就不会进入目标页
})

export default router
